module.exports = "../../static/img/marker-icon.2273e3d.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/leaflet/dist/images/marker-icon.png
// module id = 1191
// module chunks = 1